import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e } from "../../core/maybe.js";
import { createScreenPointArray as t } from "../../core/screenUtils.js";
import { makeDehydratedPoint as i } from "../../layers/graphics/dehydratedFeatures.js";
import { getConvertedElevation as s, getZForElevationMode as o } from "../../support/elevationInfoUtils.js";

var r = /*#__PURE__*/function () {
  function r(e, t, i) {
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, r);

    this.elevationInfo = e, this.defaultZ = t, this.view = i, this.excludeGraphics = s;
  }

  _createClass(r, [{
    key: "screenToMap",
    value: function screenToMap(i) {
      if (e(this.defaultZ)) return this.view.sceneIntersectionHelper.intersectElevationFromScreen(t(i.x, i.y), this.elevationInfo, this.defaultZ, this.excludeGraphics);
      var s = this.view.sceneIntersectionHelper.intersectElevationFromScreen(t(i.x, i.y), this.elevationInfo, 0, this.excludeGraphics);
      return e(s) && (s.z = void 0), s;
    }
  }, {
    key: "mapToScreen",
    value: function mapToScreen(e) {
      var t = i(e.x, e.y, s(this.view, e, this.elevationInfo), e.spatialReference);
      return this.view.toScreen(t);
    }
  }]);

  return r;
}();

var n = /*#__PURE__*/function () {
  function n(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, n);

    this.view = e, this.elevationInfo = t, this.exclude = i;
  }

  _createClass(n, [{
    key: "screenToMap",
    value: function screenToMap(t) {
      var i = this.view.toMap(t, {
        exclude: this.exclude
      });
      return e(i) && (i.z = o(i, this.view, this.elevationInfo)), i;
    }
  }, {
    key: "mapToScreen",
    value: function mapToScreen(t) {
      var o = t;
      return e(this.elevationInfo) && (o = i(t.x, t.y, s(this.view, t, this.elevationInfo), t.spatialReference)), this.view.toScreen(o);
    }
  }]);

  return n;
}();

var c = function c(e) {
  _classCallCheck(this, c);

  this.view = e, this.screenToMap = function (t) {
    return e.toMap(t);
  }, this.mapToScreen = function (t) {
    return e.toScreen(t);
  };
};

export { r as ElevationDrawSurface, c as MapDrawSurface, n as SceneDrawSurface };